module.exports = __webpack_public_path__ + "b2cdde0731f3d4fb5c95ddf32fc8a3fd.jpg";